<template>
    <section class="quote light pink">
        <circles-layout></circles-layout>

        <v-quote>Uiteindelijk wil je niet alleen jezelf verbeteren, maar samen met studenten het onderwijs verbeteren. Je moet vanuit de studenten denken en de verbinding opzoeken, dan maak je écht een verschil.</v-quote>

        <v-author>– Kirsten Cuppen, Docent ROC Tilburg</v-author>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    import Quote from '@/app/components/quotations';
    import QuoteAuthor from '@/app/components/quotation-author';

    export default {
        name: 'OnderwijskwaliteitQuote',
        meta: {
            title: 'Onderwijskwaliteit',
            color: '#fe1362'
        },
        components: {
            'circles-layout': Circles,
            'v-quote': Quote,
            'v-author': QuoteAuthor
        },
        methods: {
            focus()
            {
                // console.log( 'animateIn' );
            }
        }
    };
</script>
